import React, { Component } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { bemClassNames } from "@shared/core/utils";

function tagPropToStyle({ bgColor, borderColor, textColor } = {}) {
  const padding = borderColor ? undefined : "0";
  return {
    backgroundColor: bgColor || "transparent",
    borderColor: borderColor || "transparent",
    color: textColor || "inherit",
    paddingLeft: padding,
    paddingRight: padding,
  };
}

export default class RoomTagList extends Component {
  render() {
    const { tags, className, ignoreStyles } = this.props;
    return (
      <ul className={cx(className, bemClassNames("room-tags", this.props.properties))}>
        {(tags || []).map(tag => {
          return (
            <li key={tag.tagId}>
              <div className="room-tag" style={ignoreStyles ? {} : tagPropToStyle(tag)}>
                {tag.tagName}
              </div>
            </li>
          );
        })}
      </ul>
    );
  }
}

RoomTagList.propTypes = {
  className: PropTypes.string,
  properties: PropTypes.array,
  tags: PropTypes.array.isRequired,
  ignoreStyles: PropTypes.bool,
};

RoomTagList.defaultProps = {
  className: "",
  properties: [],
  ignoreStyles: false,
};

require("./tag-list.less");